import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import LandingPage from "./pages/LandingPage";
import Listing from "./components/landingPage/Listing";
import Register from './pages/Register';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import DashboardLayout from './components/layout/DashboardLayout';
import Product from './pages/Product';
import { AuthProvider, useAuth } from './context/AuthContext';
import Demand from './pages/Demand';
import MatchPage from './pages/MatchPage';
import VerifyEmail from './pages/VerifyEmail';
import AdminLogin from './components/admin/pages/AdminLogin';
import AdminDashboard from './components/admin/pages/AdminDashboard';
import AdminRoute from './components/admin/AdminRoute';
import RegistrationSuccess from './pages/RegistrationSuccess';
import ResendVerification from './pages/ResendVerification';
import Settings from './pages/Settings';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';

// A simple PrivateRoute component to protect routes
const PrivateRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-custom-light-gray flex items-center justify-center font-inter text-custom-teal text-xl">
        <svg className="animate-spin h-8 w-8 mr-3 text-custom-teal" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        Loading application...
      </div>
    );
  }

  return isAuthenticated ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <div className="App min-h-screen bg-gray-100">
      <HelmetProvider>
        <Router>
          <AuthProvider>
            <Routes>
              {/* Public routes */}
              <Route path="/" element={<Listing />} />
              <Route path="/landing-page" element={<LandingPage />} />
              <Route path="/register" element={<Register />} />
              <Route path="/login" element={<Login />} />
              <Route path="/verify-email" element={<VerifyEmail />} />
              <Route path="/registration-success" element={<RegistrationSuccess />} />
              <Route path="/resend-verification" element={<ResendVerification />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              
              {/* Admin routes */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin/dashboard"
                element={
                  <AdminRoute>
                    <AdminDashboard />
                  </AdminRoute>
                }
              />

              {/* Protected dashboard routes */}
              <Route path="/dashboard" element={<PrivateRoute><DashboardLayout><Dashboard /></DashboardLayout></PrivateRoute>} />
              <Route path="/products" element={<PrivateRoute><DashboardLayout><Product /></DashboardLayout></PrivateRoute>} />
              <Route path="/demand-center" element={<PrivateRoute><DashboardLayout><Demand /></DashboardLayout></PrivateRoute>} />
              <Route path="/match" element={<PrivateRoute><DashboardLayout><MatchPage /></DashboardLayout></PrivateRoute>} />
              <Route path="/settings" element={<PrivateRoute><DashboardLayout><Settings /></DashboardLayout></PrivateRoute>} />

              {/* Catch-all route - MUST BE LAST */}
              <Route path="*" element={<Navigate to="/" />} />
            </Routes>
          </AuthProvider>
        </Router>
      </HelmetProvider>
    </div>
  );
}

export default App;